import { generatePath, NavLink } from 'react-router-dom';
import {
  IconAttention,
  IconExpand,
  IconSearch,
  InputText,
  PermissionEnum,
} from '@ui/src';
import { DocumentsTopTypes } from '../types';
import { CustomerStatus, OrganizationType } from '../../types';
import DocumentsControls from '../../../../components/common/documents/controls';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';

const DocumentsTop = ({
  expiredDocuments,
  expiredDocumentsPagination,
  setExpiredDocumentsVisible,
  type,
  activePermissions,
  organizationStatus,
  customerId,
  search,
  allDocumentsSelected,
  selectedDocumentsCountByCategory,
  setMenuVisible,
  menuVisible,
  moveInProgress,
  selectedCategory,
  allowedCategories,
  documentsByCategoryId,
  allDocuments,
  changeCustomerDocumentsCategoryAction,
  otherActionsMenuVisible,
  setOtherActionsMenuVisible,
  statusChangeInProgress,
  setSelectedStatus,
  changeCustomerDocumentsStatusAction,
  selectedStatus,
  setDeletePopupVisible,
  getFiles,
  downloadInProgress,
  isFetching,
  searchText,
  activeLabel,
  onSearch,
  setActiveLabel,
}: DocumentsTopTypes) => {
  let link;

  if (type === OrganizationType.INDIVIDUAL) {
    link = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS_ADD, {
      customerId: customerId as string,
    });
  } else {
    link = generatePath(ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS_ADD, {
      customerId: customerId as string,
    });
  }

  return (
    <>
      {expiredDocuments &&
        expiredDocuments?.length > 0 &&
        expiredDocumentsPagination && (
          <div className={cn.customerDocumentsExpiredBlock}>
            <div className={cn.customerDocumentsExpiredBlockContent}>
              <IconAttention />
              <div className={cn.customerDocumentsExpiredBlockContentText}>
                {`${expiredDocumentsPagination?.totalCount} document${
                  expiredDocumentsPagination?.totalCount > 1 ? 's' : ''
                } expired`}
              </div>
              <button
                className={cn.customerDocumentsExpiredBlockLink}
                type="button"
                onClick={() => setExpiredDocumentsVisible(true)}
              >
                Show
              </button>
            </div>
          </div>
        )}
      <div className={cn.customerDocumentsTop}>
        <div className={cn.customerDocumentsTopLeft}>
          {((type === OrganizationType.INDIVIDUAL &&
            activePermissions?.includes(
              PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_CREATE_ACTION,
            )) ||
            (type === OrganizationType.CORPORATE &&
              activePermissions?.includes(
                PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_CREATE_ACTION,
              ))) &&
            organizationStatus !== CustomerStatus.CLOSED && (
              <NavLink
                to={`${link}${search || ''}`}
                className={cn.customersDocumentsCreateLink}
              >
                <div className={cn.customersDocumentsCreateLinkContent}>
                  <IconExpand className={cn.customersDocumentsCreateLinkIcon} />
                  <span>Add documents</span>
                </div>
              </NavLink>
            )}
          {(allDocumentsSelected > 0 ||
            selectedDocumentsCountByCategory > 0) && (
            <DocumentsControls
              setMenuVisible={setMenuVisible}
              menuVisible={menuVisible}
              moveInProgress={moveInProgress}
              selectedCategory={selectedCategory}
              allDocumentsSelected={allDocumentsSelected}
              selectedDocumentsCountByCategory={
                selectedDocumentsCountByCategory
              }
              allowedCategories={allowedCategories}
              documentsByCategoryId={documentsByCategoryId}
              allDocuments={allDocuments}
              changeCustomerDocumentsCategoryAction={
                changeCustomerDocumentsCategoryAction
              }
              otherActionsMenuVisible={otherActionsMenuVisible}
              type={type}
              setOtherActionsMenuVisible={setOtherActionsMenuVisible}
              activePermissions={activePermissions}
              statusChangeInProgress={statusChangeInProgress}
              setSelectedStatus={setSelectedStatus}
              changeCustomerDocumentsStatusAction={
                changeCustomerDocumentsStatusAction
              }
              selectedStatus={selectedStatus}
              setDeletePopupVisible={setDeletePopupVisible}
              getFiles={getFiles}
              downloadInProgress={downloadInProgress}
              isFetching={isFetching}
            />
          )}
        </div>
        <div className={cn.customerDocumentsTopRight}>
          <InputText
            name="search"
            placeholder="Search by docs..."
            className={`borderless ${cn.customerDocumentsSearchInput}`}
            prefix={<IconSearch />}
            labelClassName={`${cn.customerDocumentsSearchLabel} ${
              searchText || activeLabel
                ? cn.customerDocumentsSearchInputActive
                : ''
            }`}
            value={searchText}
            onChange={(e) => onSearch(e.target.value)}
            onBlur={() => setActiveLabel(false)}
            onFocus={() => setActiveLabel(true)}
          />
        </div>
      </div>
    </>
  );
};

export default DocumentsTop;
